import React from 'react';
import { getInfoText } from '../components';
import { locale } from '../utils/getLocale';


export default function BranchGrid ({ branches, selectedBranchId, onSelectBranch}){

       return (
        <div className="branch-selector-grid">
        {branches.map(branch => {
          const isSelected = selectedBranchId === branch.id;
          const infoText = getInfoText(branch);
          return (
            <button
              key={branch.id}
              data-branch-id={branch.id}
              onClick={() => onSelectBranch && onSelectBranch(branch.id)}
              className={`branch-button ${isSelected ? 'selected' : ''}`}
            >
               <div className="branch-button__indicator">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="9" cy="9" r="8.5" fill="#FFFDF5" stroke="#F3EFE1"/>
                    <circle className='inner_cb' cx="9" cy="9" r="6" fill="none"/>
                </svg>
               </div>
  
              <div className="branch-button__content">
                <div className={`branch-button__name ${isSelected ? 'selected' : ''}`}>
                  {branch.title}
                </div>
                <div className="branch-button__info">
                  {infoText}
                </div>
              </div>
              <div className="branch-button__details lg:hidden">
                 <strong>{locale('Branch locations')}</strong>
                  <div className="addresses">
                    {branch.addresses && branch.addresses.length > 0 && (
                      <ul>
                      {branch.addresses.map((address, index) => (
                        <li key={index}><span>{address}</span></li>
                      ))}
                    </ul>
                    )}             
                    </div>
              </div>
            </button>
          );
        })}
      </div>
    );
}
